import { Injectable } from '@angular/core';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/overlay';
import { DialogWrapperComponent } from './dialog-wrapper.component';

@Injectable()
export class DialogWrapperOpenerService extends MatDialog {
  public openDialog<T>(componentType: ComponentType<T>, config?: MatDialogConfig<any>) {
    if (!config.data.title || !config.data.buttontext) {
      throw Error('title and buttontext must be set');
    }

    const dialogRef = this.open(DialogWrapperComponent, config);
    dialogRef.componentInstance.title = config.data.title;
    dialogRef.componentInstance.buttontext = config.data.buttontext;
    dialogRef.componentInstance.componentType = componentType;
    dialogRef.componentInstance.dialogRef = dialogRef;
    dialogRef.componentInstance.init();

    return dialogRef;
  }
}
